import { Outlet, useMatch } from 'react-router';

import { LanguageSwitcherDropdown } from '@features/languageSwitcher';

import { PATHS } from '@shared/constants';
import { usePageTitle } from '@shared/lib/hooks';

import s from './PublicLayout.module.css';

export const Switcher = () => (
	<div className={s.publicLayout_switcher}>
		<LanguageSwitcherDropdown />
	</div>
);

export const PublicLayout = () => {
	const isAuthPage = useMatch(PATHS.AUTH);

	usePageTitle();

	return (
		<div className={s.publicLayout}>
			{isAuthPage && <Switcher />}

			<Outlet />
		</div>
	);
};
